import { render } from "./AgencyRecords.vue?vue&type=template&id=5e8c75ca&scoped=true"
import script from "./AgencyRecords.vue?vue&type=script&lang=js"
export * from "./AgencyRecords.vue?vue&type=script&lang=js"

import "./AgencyRecords.vue?vue&type=style&index=0&id=5e8c75ca&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8c75ca"]])

export default __exports__